import { USER } from "./action";

const userDefault = {
  logged: false,
  verified: false,
  signupVerified: false,
  Error: "",
};

export function userReducer(state = userDefault, action) {
  var user = Object.assign({}, state);
  switch (action.type) {
    case USER.signup.start:
      return Object.assign({}, state, {
        Error: action.data,
        Success: false
      });
    case USER.login.error:
      return {
        ...state,
        loginError: action.data
      };
    case USER.login.success:
    case USER.verify.success:
      user.verified = true;
      user.logged = true;
      user.signupVerified = false;
      Object.assign({}, state, {
        user: action.user
      });
      return user;
    case USER.signup.success:
    case USER.logout.success:
      user.logged = false;
      user.signupVerified = false;
      return Object.assign({}, state, {
        Success: action.data
      });
    case USER.signup.error:
      return Object.assign({}, state, {
        Error: action.data
      });
    case USER.signup.verified:
      action.user.signupVerified = true;
      return Object.assign({}, state, action.user);
    case USER.verify.error:
      user.verified = true;
      return user;
    case USER.isUserEnabled.success:
      return {
        ...state,
        isEnabled: action.data.isEnabled,
        userEmail: action.data.email
      };
    default:
      return user;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/redux/reducer.js